import Vue from "vue"
import {
  CContainer,
  CWrapper,
  CToaster,
  CToast,
  CModal,
  CBadge,
  CHeader,
  CSubheader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownMenu,
  CDropdownItem,
  CToggler,
  CSidebar,
  CSidebarBrand,
  CSidebarMinimizer,
  CFooter,
  CIcon,
  CCard,
  CCardHeader,
  CCardBody,
  CCardFooter,
  CInput,
  CTextarea,
  CButton,
  CButtonGroup,
  CAlert,
  CDataTable,
  CPagination,
  CTab,
  CTabs,
  CInputCheckbox,
  CListGroup,
  CListGroupItem,
  CSwitch,
  CImg
} from "@coreui/vue"
Vue.component("CContainer", CContainer)
Vue.component("CWrapper", CWrapper)
Vue.component("CToaster", CToaster)
Vue.component("CToast", CToast)
Vue.component("CBadge", CBadge)
Vue.component("CModal", CModal)
Vue.component("CHeader", CHeader)
Vue.component("CSubheader", CSubheader)
Vue.component("CHeaderBrand", CHeaderBrand)
Vue.component("CHeaderNav", CHeaderNav)
Vue.component("CHeaderNavItem", CHeaderNavItem)
Vue.component("CHeaderNavLink", CHeaderNavLink)
Vue.component("CDropdown", CDropdown)
Vue.component("CDropdownDivider", CDropdownDivider)
Vue.component("CDropdownHeader", CDropdownHeader)
Vue.component("CDropdownItem", CDropdownItem)
Vue.component("CDropdownMenu", CDropdownMenu)
Vue.component("CToggler", CToggler)
Vue.component("CSidebar", CSidebar)
Vue.component("CSidebarBrand", CSidebarBrand)
Vue.component("CSidebarMinimizer", CSidebarMinimizer)
Vue.component("CIcon", CIcon)
Vue.component("CFooter", CFooter)
Vue.component("CCard", CCard)
Vue.component("CCardHeader", CCardHeader)
Vue.component("CCardBody", CCardBody)
Vue.component("CCardFooter", CCardFooter)
Vue.component("CInput", CInput)
Vue.component("CTextarea", CTextarea)
Vue.component("CButton", CButton)
Vue.component("CButtonGroup", CButtonGroup)
Vue.component("CAlert", CAlert)
Vue.component("CDataTable", CDataTable)
Vue.component("CPagination", CPagination)

Vue.component("CTab", CTab)
Vue.component("CTabs", CTabs)
Vue.component("CInputCheckbox", CInputCheckbox)
Vue.component("CListGroup", CListGroup)
Vue.component("CListGroupItem", CListGroupItem)
Vue.component("CSwitch", CSwitch)
Vue.component("CImg", CImg)
